<template>
<v-container>
   <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>

    </v-app-bar>
  </nav>

  <template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left" style="color:white;">
            DB Board
          </th>
          <th class="text-left" style="color:white;">
            Phase Label
          </th>
          <th class="text-left" style="color:white;">
            Location (Room by Google)
          </th>
          <th class="text-left" style="color:white;">
            8CH Current Sensor Label
          </th>
          <th class="text-left" style="color:white;">
            8CH CS Individual Channel Label
          </th>
          <th class="text-left" style="color:white;">
            8CH Current Sensor S/N
          </th>
          <th class="text-left" style="color:white;">
            Modbus Address
          </th>
          <th class="text-left" style="color:white;">
            Load Type 
          </th>
 
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName1A }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb1A.label }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location1A.location }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">A</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">1</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_1A.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
      <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName1B }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb1B.label }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location1B.location }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">B</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">1</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_1B.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName1C }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb1C.label }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location1C.location }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">C</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">1</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_1C.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName1D }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb1D.label }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location1D.location }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">D</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">1</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_1D.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName1E }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb1E.label }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location1E.location }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">E</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">1</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_1E.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName1F }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb1F.label }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location1F.location }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">F</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">1</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_1F.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName1G }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb1G.label }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location1G.location }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">G</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">1</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_1G.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName1H }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb1H.label }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location1H.location }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">H</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">1</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_1H.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
      <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName2A }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb2A.label }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location2A.location }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">A</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">2</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_2A.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
      <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName2B }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb2B.label }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location2B.location }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">B</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">2</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_2B.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName2C }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb2C.label }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location2C.location }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">C</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">2</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_2C.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName2D }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb2D.label }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location2D.location }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">D</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">2</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_2D.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName2E }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb2E.label }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location2E.location }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">E</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">2</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_2E.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName2F }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb2F.label }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location2F.location }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">F</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">2</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_2F.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName2G }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb2G.label }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location2G.location }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">G</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">2</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_2G.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName2H }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb2H.label }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location2H.location }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">H</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">2</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_2H.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
      <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName3A }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb3A.label }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location3A.location }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">A</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">3</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_3A.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
      <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName3B }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb3B.label }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location3B.location }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">B</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">3</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_3B.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName3C }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb3C.label }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location3C.location }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">C</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">3</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_3C.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName3D }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb3D.label }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location3D.location }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">D</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">3</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_3D.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName3E }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb3E.label }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location3E.location }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">E</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">3</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_3E.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName3F }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb3F.label }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location3F.location }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">F</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">3</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_3F.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName3G }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb3G.label }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location3G.location }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">G</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">3</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_3G.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName3H }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb3H.label }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.location3H.location }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">H</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">3</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_3H.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 4">{{ item.boardName4A }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.ryb4A.label }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.location4A.location }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorLabel4 }}</td>
          <td v-if="board[0].totalSensor == 4">A</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorSn4 }}</td>
          <td v-if="board[0].totalSensor == 4">4</td>
          <td v-if="board[0].totalSensor == 4">{{ item.loadType_4A.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
      <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 4">{{ item.boardName4B }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.ryb4B.label }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.location4B.location }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorLabel4 }}</td>
          <td v-if="board[0].totalSensor == 4">B</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorSn4 }}</td>
          <td v-if="board[0].totalSensor == 4">4</td>
          <td v-if="board[0].totalSensor == 4">{{ item.loadType_4B.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 4">{{ item.boardName4C }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.ryb4C.label }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.location4C.location }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorLabel4 }}</td>
          <td v-if="board[0].totalSensor == 4">C</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorSn4 }}</td>
          <td v-if="board[0].totalSensor == 4">4</td>
          <td v-if="board[0].totalSensor == 4">{{ item.loadType_4C.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 4">{{ item.boardName4D }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.ryb4D.label }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.location4D.location }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorLabel4 }}</td>
          <td v-if="board[0].totalSensor == 4">D</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorSn4 }}</td>
          <td v-if="board[0].totalSensor == 4">4</td>
          <td v-if="board[0].totalSensor == 4">{{ item.loadType_4D.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 4">{{ item.boardName4E }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.ryb4E.label }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.location4E.location }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorLabel4 }}</td>
          <td v-if="board[0].totalSensor == 4">E</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorSn4 }}</td>
          <td v-if="board[0].totalSensor == 4">4</td>
          <td v-if="board[0].totalSensor == 4">{{ item.loadType_4E.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 4">{{ item.boardName4F }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.ryb4F.label }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.location4F.location }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorLabel4 }}</td>
          <td v-if="board[0].totalSensor == 4">F</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorSn4 }}</td>
          <td v-if="board[0].totalSensor == 4">4</td>
          <td v-if="board[0].totalSensor == 4">{{ item.loadType_4F.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 4">{{ item.boardName4G }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.ryb4G.label }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.location4G.location }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorLabel4 }}</td>
          <td v-if="board[0].totalSensor == 4">G</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorSn4 }}</td>
          <td v-if="board[0].totalSensor == 4">4</td>
          <td v-if="board[0].totalSensor == 4">{{ item.loadType_4G.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 4">{{ item.boardName4H }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.ryb4H.label }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.location4H.location }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorLabel4 }}</td>
          <td v-if="board[0].totalSensor == 4">H</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorSn4 }}</td>
          <td v-if="board[0].totalSensor == 4">4</td>
          <td v-if="board[0].totalSensor == 4">{{ item.loadType_4H.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  <!-- <p>{{loadTypeA}}</p> -->
   
</template>
<v-btn fixed dark fab bottom right color="green" :to="{ name: 'Board Edit', params: { id: this.$route.params.id } }">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
</v-container>
</template>

<script>
import axios from "axios";

  export default {
    data () {
      return {
        items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Settings',
          disabled: true,
          href: '',
        },
        {
          text: '8 Channel Phase',
          disabled: false,
          href: '/board',
        },
        {
          text: 'Details',
          disabled: true,
          href: '',
        },
      ],
        board: []
      }
    },
    mounted() {
    this.loadsBoard();
  },
    methods:{
      loadsBoard: async function(){
      let apiURL = process.env.VUE_APP_API + "/api/board/list/" + this.$route.params.id;
      axios.get(apiURL).then(res => {
      this.board = res.data;
      }).catch(error => {
      console.log(error)
      });
},
    }
  }
</script>

<style scoped>
table, th, td {
  border: 2px groove;
}
th{
  background-color: rgb(35, 35, 35);
}
</style>